import { render, staticRenderFns } from "./latestpurprice.vue?vue&type=template&id=0407ae36&scoped=true&"
import script from "./latestpurprice.vue?vue&type=script&lang=js&"
export * from "./latestpurprice.vue?vue&type=script&lang=js&"
import style0 from "./latestpurprice.vue?vue&type=style&index=0&id=0407ae36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0407ae36",
  null
  
)

export default component.exports